import type { datadogLogs } from '@datadog/browser-logs'

export default defineNuxtPlugin({
  async setup(nuxtApp) {
    const logger: CanxLogger = {
      log: (message, ctx) => {
        (nuxtApp.$datadogLogs as (typeof datadogLogs)).logger.log(message, ctx)
        console.log(message)
      },
      error: (message, ctx, error) => {
        (nuxtApp.$datadogLogs as (typeof datadogLogs)).logger.error(message, ctx, error)
        console.error(message, ctx)
      },
    }

    return {
      provide: {
        logger,
      },
    }
  },
})
